import { render, staticRenderFns } from "./EducationItemCard.vue?vue&type=template&id=fe60270a&scoped=true"
import script from "./EducationItemCard.vue?vue&type=script&lang=js"
export * from "./EducationItemCard.vue?vue&type=script&lang=js"
import style0 from "./EducationItemCard.vue?vue&type=style&index=0&id=fe60270a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe60270a",
  null
  
)

export default component.exports